import { Injectable } from '@angular/core';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class ServerConnectionService {

  private urlServer: string;

  constructor(private envService: EnvService) {
    // POR PARAMETRO
    this.urlServer = this.envService.apiUrl;

    //DEV - LOCAL
    //this.urlServer = 'http://localhost:8443';

    //PROD - DNS
    //this.urlServer = 'https://atenea.airfal.com:8443';

    //PRE PROD - DNS
    //this.urlServer = 'https://preproduccion.atenea.airfal.com:8443';
  }

  public getUrlServer(): string {
    return this.urlServer;
  }

}
